// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".header_EkQu9{display:grid;padding:24px 0 27px;grid-gap:16px;gap:16px}@media only screen and (min-width:1264px){.header_EkQu9{grid-template-columns:1fr 445px;padding:16px 0 24px}}.info_APirN{display:grid;grid-gap:4px;gap:4px;text-align:center}@media only screen and (min-width:1264px){.info_APirN{text-align:left;grid-gap:8px;gap:8px}}.title_F1rnb{font-size:20px;font-weight:600;line-height:28px}@media only screen and (min-width:1264px){.title_F1rnb{font-size:40px;line-height:48px}}.text_6V9ZP{font-size:14px;line-height:20px}@media only screen and (min-width:1264px){.text_6V9ZP{font-size:18px;line-height:26px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": "header_EkQu9",
	"info": "info_APirN",
	"title": "title_F1rnb",
	"text": "text_6V9ZP"
};
module.exports = ___CSS_LOADER_EXPORT___;
